import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { Overrides } from '@material-ui/core/styles/overrides';

import variables from './variables';

const defaultTheme = createMuiTheme();

const overridesCustomizer: Overrides = {
  MuiButton: {
    root: {
      paddingLeft: 20,
      paddingRight: 20,
      fontFamily: 'Lato !important'
    },
    sizeSmall: {
      paddingLeft: 15,
      paddingRight: 15
    },
    outlined: {
      color: '#FFF !important',
      borderColor: '#FFF !important'
    }
  },
  MuiFormLabel: {
    root: {
      transform: 'none !important',
      fontSize: 12
    }
  },
  MuiInput: {
    root: {
      borderRadius: 4,
      backgroundColor: defaultTheme.palette.common.white,
      border: '1px solid #ced4da',
      fontSize: 16,
      fontFamily: 'Lato',
      color: variables.colors['text'],
      padding: '7px 10px',
      transition: defaultTheme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
      },
      '&:before': {
        display: 'none'
      }
    },
    multiline: {
      padding: '7px 10px'
    }
  },
  MuiInputLabel: {
    root: {
      fontSize: 16,
      color: variables.colors['label'],
      fontFamily: 'Lato',
      fontWeight: 'bold',
      transform: 'translate(0, -8px) !important',
      borderColor: variables.colors['inputBorder']
    }
  },
  MuiMenuItem: {
    root: {
      fontFamily: 'Lato'
    }
  },
  MuiTypography: {
    title: {
      color: `${variables.colors['customizerTitle']} !important`,
      fontFamily: 'Lato',
      fontSize: '16px !important',
      fontWeight: 'bold'
    },
    h6: {
      color: `${variables.colors['customizerTitle']} !important`,
      fontFamily: 'Lato',
      fontSize: '16px !important',
      fontWeight: 'bold'
    },
    subheading: {
      color: variables.colors['title'],
      fontFamily: 'Lato',
      fontSize: 14,
      fontWeight: 'bold'
    },
    subtitle1: {
      color: variables.colors['label'],
      fontSize: 16,
      fontFamily: 'Lato',
      fontWeight: 'bold'
    },
    body1: {
      color: variables.colors['text'],
      fontFamily: 'Lato',
      lineHeight: 1.35
    },
    body2: {
      color: variables.colors['text'],
      fontFamily: 'Lato',
      lineHeight: 1.35
    }
  },
  MuiTableRow: {
    root: {
      height: 35
    }
  },
  MuiTableCell: {
    root: {
      padding: '3px 0 3px 0',
      fontFamily: 'Lato',
      '&:last-child': {
        paddingRight: 0
      }
    },
    body: {
      fontSize: 14
    }
  },
  MuiDialogTitle: {
    root: {
      fontWeight: 'bold',
      color: variables.colors['title'],
      fontSize: 24,
      textAlign: 'center'
    }
  },
  MuiFormControlLabel: {
    label: {
      fontSize: 16,
      fontFamily: 'Lato',
      color: variables.colors['text']
    }
  },
  MuiTab: {
    root: {
      minWidth: 'auto !important',
      borderBottom: '4px solid #D8D8D8'
    },
    label: {
      textTransform: 'capitalize',
      fontFamily: 'Lato',
      fontSize: '16px !important',
      fontWeight: 'bold',
      color: variables.colors['text']
    },
    wrapper: {
      flexDirection: 'row',
      '& svg': {
        width: 20
      }
    },
    labelContainer: {
      width: 'auto',
      paddingLeft: '8px !important',
      paddingRight: '8px !important'
    },
    labelIcon: {
      minHeight: 50
    }
  },
  MuiTabs: {
    indicator: {
      backgroundColor: variables.colors['tabsIndicator'],
      height: 4
    }
  },
  MuiSwitch: {
    bar: {
      borderRadius: 13,
      width: 42,
      height: 26,
      marginTop: -13,
      marginLeft: -21,
      border: 'solid 1px',
      borderColor: defaultTheme.palette.grey[400],
      backgroundColor: defaultTheme.palette.grey[50],
      opacity: 1,
      transition: defaultTheme.transitions.create(['background-color', 'border'])
    },
    icon: {
      width: 24,
      height: 24
    },
    iconChecked: {
      boxShadow: defaultTheme.shadows[1],
      backgroundColor: '#FFFFFF !important'
    },
    checked: {
      transform: 'translateX(15px)',
      '& + $bar': {
        backgroundColor: '#009358 !important',
        opacity: 1,
        border: 'none'
      }
    }
  }
};

export default overridesCustomizer;
